import { render, staticRenderFns } from "./LayoutWithoutMenu.vue?vue&type=template&id=1160bc7e&scoped=true"
import script from "./LayoutWithoutMenu.vue?vue&type=script&lang=js"
export * from "./LayoutWithoutMenu.vue?vue&type=script&lang=js"
import style0 from "./LayoutWithoutMenu.vue?vue&type=style&index=0&id=1160bc7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1160bc7e",
  null
  
)

export default component.exports